class UrlHelper {
  static toQueryString(params: Record<string, string | number | boolean>) {
    const query = Object.entries(params).reduce((acc, [key, value], index) => {
      const isLastItem = index === Object.keys(params).length - 1
      const separator = !isLastItem ? '&' : ''
      // eslint-disable-next-line no-param-reassign
      acc += `${key}=${value}${separator}`

      return acc
    }, '')

    return query || ''
  }
}

export default UrlHelper
